module.exports = __webpack_public_path__ + "media/images/shapes/shape-3-455814647aec095abbcf72f05d699728.svg";